import React from "react";
import { useSelector } from "react-redux";
import Header from "../../component/users/Header";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Typography,
  Checkbox,
  Link,
  FormHelperText,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Container,
} from "@mui/material";
import Options from "../../component/users/Home/Options";
import Crousel from "../../component/users/Home/Crousel";
import GoalVideos from "../../component/users/Home/GoalVideos";
import HomeSkeleton from "../../component/users/Home/Skeleton";

const Goals = () => {
  const userData = useSelector((state) => state.loggedUser.user);
  const user = useSelector((state) => state.user.loading);
  return (
    <>
      <Header />
      {user ? (
        <HomeSkeleton />
      ) : (
        <Box className="userLayout">
          <Container
            disableGutters={true}
            maxWidth="lg"
            sx={{ background: "#242743", paddingBottom: "116px" }}
          >
            <Options />
            <Box className="homePage-content">
              <GoalVideos />
            </Box>
          </Container>
        </Box>
      )}
    </>
  );
};

export default Goals;
